$(document).ready(function () {
    if (document.getElementById('bloc-devis') || document.querySelector('.bloc-devis-ajax')) {
        function setLiContent(el, loading) {
            var label = el.dataset.label;
            var src = el.dataset.src;

            loading = loading || false;
            var icon = loading ? 'spinner fa-spin' : 'file-pdf';
            var href = loading ? '' : 'href="' + src + '"';
            var textClass = loading ? 'text-dusty-gray' : 'text-dark';

            el.innerHTML = '<i class="fas fa-' + icon + ' mr-2 ' + textClass + '"></i>' + (loading ? '' : ' ') +
                '<a ' + href + (!loading ? 'target="_blank" rel="noopener"' : '') +
                'class="font-weight-bold ' + textClass + ' font-15">' + label + '</a>';
        }

        function testPdfPresence(el) {
            axios.head(el.dataset.src).then(
                function(response) {
                    if (response.headers['content-type'] === 'application/pdf') {
                        setLiContent(el, false);
                    } else {
                        setTimeout(function(){testPdfPresence(el)}, 3000);
                    }
                }
            ).catch(function(error) {
                setTimeout(function(){testPdfPresence(el)}, 3000);
            });
        }

        function doDocsLoading() {
            var documentElements = document.getElementsByClassName('devis-doc-chargement');
            for (var i = 0; i < documentElements.length; i++) {
                testPdfPresence(documentElements[i]);
            }
        }

        function checkBlockDevisPresence() {
            if (document.getElementById('bloc-devis')) {
                doDocsLoading();
            } else {
                setTimeout(checkBlockDevisPresence, 1000);
            }
        }

        checkBlockDevisPresence();
    }
});
